import './styles/index-core.css';
import './styles/site-overrides.css';
import './styles/legacy-patches.css';
import './styles/interface-ux.css';

import { loadLegacyApp } from './legacy/loadLegacyApp';
import { initLegacyDomPatches, registerLegacyPreloadPatches } from './legacy/patches';
import { initRuntime } from './runtime';

async function bootstrap(): Promise<void> {
  initRuntime();
  registerLegacyPreloadPatches();

  await loadLegacyApp();

  initLegacyDomPatches();
}

bootstrap().catch((error) => {
  console.error('Errore avvio applicazione I.M. Distribuzione:', error);

  const root = document.getElementById('root');
  if (root && !root.innerHTML.trim()) {
    root.innerHTML = `
      <main style="min-height:100vh;display:grid;place-items:center;background:#0f172a;color:white;font-family:Inter,system-ui,sans-serif;padding:2rem;text-align:center;">
        <div>
          <h1 style="font-size:1.6rem;margin-bottom:.75rem;">Errore caricamento applicazione</h1>
          <p style="color:#cbd5e1;max-width:42rem;line-height:1.6;">Ricarica la pagina. Se il problema persiste, verifica che il bundle legacy sia presente in <code>/public/assets/index-D6mQ7Yeu.js</code>.</p>
        </div>
      </main>
    `;
  }
});
